import { FightEvent, SetupFightEvent } from 'web/data/models'

export function isSetupFightEvent(event: FightEvent | SetupFightEvent): event is SetupFightEvent {
    if ((event as SetupFightEvent).setupId) {
        return true
    }

    return false
}
